import { useMemo } from 'react';
import { useAuth } from '../../../Hooks/useAuth';
import './ResellerReport.scss';
import { Encrypt } from '../../../Utils/encrypt-decrypt';
import { MIS_RESELLER_REPORT } from '../../../Constants/strings';
import ResellerReportTableToolbar from './ResellerReportToolbar';
import { ResellerReportProvider } from '../../../Contexts/ResellerReportContext';
import ResellerReportTable from './ResellerReportTable';
import ImportError from '../ResellerComponents/ImportError';

const ResellerReport = () => {
  return (
    <ResellerReportProvider>
      <div className="reseller-report-outer-layer">
        <div className="reseller-report-title-outer-layer">
          <h1 className="reseller-report-title">{MIS_RESELLER_REPORT.TITLE}</h1>
          <AccountingLink />
        </div>
        <div className="reseller-report">
          <div className="reseller-report-table-outer-layer">
            <ResellerReportTableToolbar/>
            <ImportError/>
            <ResellerReportTable/>
          </div>
        </div>
      </div>
    </ResellerReportProvider>
  );
};

const AccountingLink = () => {
  const { userProfile } = useAuth();
  const resellerAppUrl = process.env.REACT_APP_RESELLER_URL
    ? process.env.REACT_APP_RESELLER_URL
    : '';
  const token = encodeURIComponent(Encrypt(userProfile.access_token));
  const accountingReportUrl = useMemo(
    () => `${resellerAppUrl}?d_tkn=${token}`,
    [userProfile],
  );
  return (
    <a
      href={accountingReportUrl}
      className="accounting-report-link"
      target="_blank"
      rel="noopener noreferrer"
    >
        Accounting Report
    </a>
  );
};

export default ResellerReport;
